import React, { Component } from "react";
import { connect } from "react-redux";
import { Table } from "react-bootstrap";

class MemberList extends Component {
    render() {
        return (
            <Table size="sm" responsive>
                <thead>
                <tr>
                    <th>Member Since</th>
                    <th>Owner</th>
                    <th>Phone Number</th>
                    <th>Email Address</th>
                    <th>Number of Beds</th>
                    <th>Number of Residents</th>
                    <th>Number of Vacant Beds</th>
                    <th>Location</th>
                </tr>
                </thead>
                <tbody>
                <td>January 1, 2017</td>
                <td>John Smith</td>
                <td>+12345678</td>
                <td>johnsmith@gmail.com</td>
                <td>10</td>
                <td>8</td>
                <td>2</td>
                <td>8767 Ashburn Rd Leesburg VA 89000</td>
                </tbody>
            </Table>
        )
    }
}


const mapStateToProps = (state, ownProps) => {
    return {};
}

const mapDispatchToProps = (dispatch) => {
    return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(MemberList);